import type { RootState } from 'client/js/redux';
import { createSelector } from 'reselect';
import type { UiRoleId } from '../../../main/types/accessControlTypes';
import { INIT_STATE } from './constants';
import type { Settings, User, UserState } from './types';

export function getState(state: RootState): UserState {
  return (state && state.user) || INIT_STATE;
}

export function getUserState(state: RootState): UserState {
  return (state && state.user) || INIT_STATE;
}

export const getUserData: (state: RootState) => User | undefined = createSelector(
  getState,
  (userState) => (userState && userState.data) || undefined
);

export const getLimitedUserData: (state: RootState) => any = createSelector(getUserData, (userData) => {
  if (!userData) {
    return undefined;
  }
  const { name, last_name, email } = userData;
  return { name, last_name, email };
});

export const selectIsAgencyUser = createSelector(getUserData, (user: User | undefined) => {
  return user ? Boolean(user.agency_user) : false;
});

export const isLoading: (state: RootState) => boolean = createSelector(getState, (state) => {
  return state.loading;
});

export const getUserAccessRoleId: (state: RootState) => UiRoleId | undefined = createSelector(getState, (state) => {
  return (state && state.access_role_id) || undefined;
});

export const areSettingsLoading: (state: RootState) => boolean = createSelector(getState, (state) => {
  return (state && state.settingsLoading) || false;
});

const EMPTY_OBJECT = {};

export const getUserSettingsOrDefault: (state: RootState) => Settings = createSelector(getUserData, (state) => {
  return (state && state.settings) || EMPTY_OBJECT;
});

export const shouldAnalyticCalculateOrganic: (state: RootState) => boolean = createSelector(
  getUserSettingsOrDefault,
  (state) => {
    return (state && state.calculateAnalyticsOrganic) || false;
  }
);

export const getUserEmail = createSelector(getUserData, (user: User | undefined) => {
  return user?.email || '';
});

export const selectShowNewActivityView = createSelector(getState, (state: UserState) => {
  return state.adsActivityConfig?.newActivityTable || false;
});
